<main>
  <div class="user-form">
    <h1 class="h3 mb-3 font-weight-normal">Thank you for signing up!</h1>
    <p>Thank you for signing up with the QA4SM Validation Service.
    You should receive a verification email shortly. If no such email arrives after a few hours please reach out to the admin team. </p>
    <a class="p-button" [routerLink]="['/home']" role="button">Back to landing page</a>
  </div>
</main>

